import MetaTags from "./index";

const tags = {
  vod: {
    title: "お知らせ | スカパー！動画ストア",
    keywords: "スカパー！動画ストア,動画配信,見放題,レンタル,お知らせ",
    description:
      "スカパー！動画ストアからのお知らせ一覧。スカパー！動画ストアではサッカー・プロレス・格闘技などの動画を配信中！",
    og: { type: "article" },
  },
};

export default function InformationsMetaTags() {
  const props = tags["vod"];

  return <MetaTags {...props} />;
}
